import { queryOptions } from '@tanstack/react-query';
import api from '#/api';
import queryClient from '#/api/queryClient';
import type { RequestOpts } from './useLoanPortfolio';

const method = api.getDocumentsByDocumentIdSign;
// API returns SignModel for 200 response, or undefined for 204 (already signed)
export type SignDocumentResponse =
  | Awaited<ReturnType<typeof method>>
  | undefined;

type SignDocumentQueryParams = {
  documentId: string | undefined;
};

function signDocumentQuery(
  params: SignDocumentQueryParams,
  opts?: RequestOpts,
) {
  const queryKey = ['signDocument', params.documentId];
  return queryOptions<SignDocumentResponse>({
    queryKey,
    queryFn: async ({ signal }) => {
      if (!params.documentId) throw new TypeError('No documentId provided');
      // API returns undefined for 204 status (already signed document)
      return method(params.documentId, { ...opts, signal });
    },
    initialDataUpdatedAt: queryClient.getQueryState(queryKey)?.dataUpdatedAt,
  });
}

export async function fetchSignDocumentQuery(
  params: SignDocumentQueryParams,
  opts?: RequestOpts,
): Promise<SignDocumentResponse> {
  return queryClient.fetchQuery(signDocumentQuery(params, opts));
}
